import React from 'react';
import { Link } from 'react-router-dom';

const MenuMobileRegularEnUs = ({toggleMenuType}) => {
  return (
    <menu>
      <li onClick={ (e) => { toggleMenuType('products') }}>
        <span className="arrow-right">Products</span>
      </li>
      <li>
        <Link to="/conteudos">Contents</Link>
      </li>
      <li>
        <Link to="/onde-encontrar/compensados">Where to find</Link>
      </li>
      <li onClick={ (e) => { toggleMenuType('about') }}>
        <span className="arrow-right">About us</span>
      </li>
      <li>
        <Link to="/contato">Contact</Link>
      </li>
    </menu>
  )
}
          
export default MenuMobileRegularEnUs;